
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { AddAccessCode, IAddAccessCode } from '@shared/services/api/legacy/accesscodes-service/accesscodes-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class AccessCodesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${AccessCodesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/events/{eventId}/accesscodes';

    public getAccessCode(eventId: string, accessCodeId: string): Observable<SuccessResponse<IAddAccessCode> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IAddAccessCode>>(AccessCodesService.URL.replace('{eventId}', eventId) + '/' + accessCodeId).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addAccessCode(eventId: string, model: AddAccessCode): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .post<SuccessResponse<boolean>>(AccessCodesService.URL.replace('{eventId}', eventId), model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public updateAccessCode(eventId: string, model: AddAccessCode): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .put<SuccessResponse<boolean>>(AccessCodesService.URL.replace('{eventId}', eventId) + '/' + model.id, model).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public deleteAccessCode(eventId: string, accessCodeId: string): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
            .delete<SuccessResponse<boolean>>(AccessCodesService.URL.replace('{eventId}', eventId) + '/' + accessCodeId).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
